import Vue from "vue";
import Vuex from "vuex";
import cart from "./modules/cart";
import hotels from "./modules/hotels";
import app from "./modules/app";
import campingClubs from "./modules/campingClubs";
import categories from "./modules/categories";
import types from "./modules/types";
import blogs from "./modules/blogs";

import createLogger from "vuex/dist/logger";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
    storage: window.localStorage
});
const debug = process.env.NODE_ENV !== "production";
export default new Vuex.Store({
    modules: {
        app,
        cart,
        hotels,
        types,
        categories,
        campingClubs,
        blogs
    },
    strict: debug,
    plugins: debug ? [createLogger(), vuexLocal.plugin] : [vuexLocal.plugin]
});
